export default __webpack_public_path__ + "static/media/index.d3341049.png";